import TagCountGame from "./TagCountGame";
import CountEventsGame from "./CountEventsGame";
import FlashSetGame from "./FlashSetGame";
import MatchRepGame from "./MatchRepGame";
import SequenceRepairGame from "./SequenceRepairGame";
import GiveNGame from "./GiveNGame";
import CompareSetsGame from "./CompareSetsGame";
import FrameFillGame from "./FrameFillGame";
import HiddenSetGame from "./HiddenSetGame";
import TraceNumeralGame from "./TraceNumeralGame";
import RearrangeGame from "./RearrangeGame";
import NumberPathGame from "./NumberPathGame";
import PlaceValueBuilder from "./PlaceValueBuilder";

export const COUNTING_ENGINE_MAP = {
  tagCount: TagCountGame,
  countEvents: CountEventsGame,
  flashSet: FlashSetGame,
  matchRep: MatchRepGame,
  sequenceRepair: SequenceRepairGame,
  giveN: GiveNGame,
  compareSets: CompareSetsGame,
  frameFill: FrameFillGame,
  hiddenSet: HiddenSetGame,
  traceNumeral: TraceNumeralGame,
  rearrange: RearrangeGame,
  numberPath: NumberPathGame,
};

export { PlaceValueBuilder };
